import React, { useState } from "react";
import Container from "../global/container";
import * as styles from "./header.module.scss";
import FlexSpace from "../global/flex-space";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { Link } from "gatsby";

import SunIcon from '../../../static/sun.svg'
import MoonIcon from '../../../static/moon.svg'

const Header = ({ location, title, darkMode, toggleTheme }) => {
    const [showCta, setShowCta] = useState(false);

    useScrollPosition(
        (scroll) => {
            const passThreshold = scroll.currPos.y < -550;
            setShowCta(passThreshold);
        },
        [showCta]
    );

    return (
        <header className={darkMode ? 'background-dark-gradient' : 'background-light-gradient'}>
            <Container>
                <div className="d-flex justify-content-between">
                    <Link to={"/"} className={styles.brandLink}>
                        <FlexSpace>
                            <h1 className={styles.brandName}>
                                Linkd
                            </h1>
                        </FlexSpace>
                    </Link>

                    <div className="d-flex align-items-center">
                        <button onClick={toggleTheme} className={`d-flex align-items-center mr-20 ${darkMode ? 'theme-toggle theme-toggle-light' : 'theme-toggle theme-toggle-dark'}`}>
                            {darkMode ? <SunIcon /> : <MoonIcon />}
                        </button>
                        <Link
                            to={"/contact"}
                            className={
                                showCta
                                    ? styles.ctaButtonFull
                                    : styles.ctaButtonOutline
                            }>
                            Get Early Access
                        </Link>
                    </div>
                </div>
            </Container>
        </header>
    );
};

export default Header;
